import { useCompany, useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { CompanyResponse } from '@/hooks/useCompany/types';
import { useSection } from '../useSection';
type Company = CompanyResponse['data'];
function getDividendYield(company?: Company) {
  return company?.analysis?.data.extended.data.analysis.dividend.dividend_yield;
}

function useShouldNoIndexFollow() {
  const { currentSection } = useSection();
  const canonicalUrl = useCompanyCanonicalUrl();
  const company = useCompany(canonicalUrl);
  const dividendYield = getDividendYield(company.data?.data);

  const primaryCanonicalUrl = company?.data?.data.primary_canonical_url;
  const isPrimaryListing =
    company?.data?.data.canonical_url === undefined ||
    company?.data.data.canonical_url === primaryCanonicalUrl;
  const userViews90d = company?.data?.data.statistics?.data?.user_views_90d;

  const isSecondaryInsufficientUserViews =
    !isPrimaryListing && userViews90d === 0;

  console.log(isPrimaryListing, userViews90d, isSecondaryInsufficientUserViews);
  const isBlockedAsInsufficientDividend =
    (dividendYield === 0 || dividendYield === null) &&
    currentSection === 'dividend';

  return isBlockedAsInsufficientDividend || isSecondaryInsufficientUserViews;
}

export default useShouldNoIndexFollow;
